import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantStorageService } from '../services/tenant-storage.service';

/**
 * URL enrichment guard with tenant parameter (inst=XXX)
 *
 * Responsibilities ONLY:
 * 1. Synchronize tenant from URL to localStorage
 * 2. Enrich URL with stored tenant if missing
 * 3. Redirect to /auth/no-tenant if no tenant available
 */
export const tenantEnrichmentGuard: CanActivateFn = (route, state) => {
    const tenantStorage = inject(TenantStorageService);
    const router = inject(Router);

    // Exclude authentication routes
    const excludedPaths = ['/auth'];
    if (excludedPaths.some(path => state.url.startsWith(path))) {
        return true;
    }

    const urlTenant = route.queryParamMap.get('inst');
    const storedTenant = tenantStorage.getTenant();

    if (!storedTenant && !urlTenant) {
        router.navigate(['/auth/no-tenant']);
        return false;
    }

    if (urlTenant) {
        tenantStorage.setTenant(urlTenant);
        return true;
    }

    if (storedTenant) {
        const currentUrl = state.url;
        const separator = currentUrl.includes('?') ? '&' : '?';
        const enrichedUrl = `${currentUrl}${separator}inst=${encodeURIComponent(storedTenant)}`;

        router.navigateByUrl(enrichedUrl);
        return false;
    }

    return true;
};
